import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'polpo-legals-page-privacy',
  templateUrl: './legals-page-privacy.component.html',
})
export class LegalsPagePrivacyComponent {}
